import { RESOURCES_COMPONENT_TOKEN, ResourcesComponent } from '@cgs/machines';
import { Container, SceneObject } from '@cgs/wge';

export const SANTA_MULTIPLIER_HOLDER_COMPONENT_TOKEN = Symbol('SantaMultiplierHolderComponent');

const enum SceneNames {
  MultiplierHolderMod = 'SledMod',
}

const enum SceneStates {
  Off = 'off',
  On = 'on',
}

export class SantaMultiplierHolderComponent {
  private readonly multiplierHolderMod: SceneObject;

  constructor(container: Container) {
    const resourcesComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.multiplierHolderMod = resourcesComponent.root.findById(SceneNames.MultiplierHolderMod)!;
  }

  public hide(): void {
    this.multiplierHolderMod.stateMachine?.switchToState(SceneStates.Off);
  }

  public show(): void {
    this.multiplierHolderMod.stateMachine?.switchToState(SceneStates.On);
  }
}
